"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _messages = require("./messages");
const FirstLastPageButton = props => {
  const isDisabled = props.isFirstPageButton ? props.currentPage === 1 : props.currentPage === props.finalPage;
  const msgs = _messages.messages[props.language];
  return /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": props.isFirstPageButton ? msgs.first : `${msgs.last} (${isDisabled ? msgs.disabled : props.finalPage})`,
    className: "PaginationButton " + (props.isFirstPageButton ? "Pagination-firstPageButton" : "Pagination-lastPageButton"),
    disabled: isDisabled,
    onClick: props.clickHandler
  }, props.isFirstPageButton ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: "first_page",
    className: "Pagination-buttonIconLastLeft",
    size: "md"
  }) : /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: "last_page",
    className: "Pagination-buttonIconLastRight",
    size: "md"
  }));
};
var _default = exports.default = FirstLastPageButton;